import { 
    FETCH_TAG_COUNTS, 
    FETCH_TAG_IDS,
    URL 
} from './types';

export const fetchTagCounts = (token) => dispatch => {
    fetch(URL + 'api2/tagscount2/', {
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        })
    })
    .then(res=>res.json())
    .then(tags=>
        dispatch({
            type: FETCH_TAG_COUNTS,
            payload: tags
        })
    )
}

export const fetchTagIds = (token,names) => dispatch => {
    fetch(URL + "api2/gettagids/" + names + '/', {
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        })
    })
    .then(res=>res.json())
    .then(ids=>
        dispatch({
            type: FETCH_TAG_IDS,
            payload: ids
        })  
    )
}


// WEBPACK FOOTER //
// ./src/actions/tagActions.js